import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
import { Dialogs, useDialogManager } from '@/modules/Dialogs';
import useLifecycleBoards from '../lib/hooks/useLifecycleBoards';
import { useLifecycleBoardContext } from './LifecycleBoardContext';

const MENU_ID = 'lifecycle-board-menu';
const MENU_CLASSES = { list: 'pb-0' };

function LifecycleBoardSwitcher() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { data: boards } = useLifecycleBoards();
  const { board } = useLifecycleBoardContext();
  const { isOrgAdmin } = useCurrentUser(true);
  const closeMenu = () => setAnchorEl(null);
  const { openDialog, closeDialog } = useDialogManager();

  return (
    <div className="px-4 pt-4">
      <h2>
        <button
          className="flex items-center type-h2 md:type-h1"
          type="button"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-controls={anchorEl ? MENU_ID : undefined}
          aria-haspopup="true"
        >
          {board?.boardTitle}
          <div className="ml-2 flex flex-col items-center">
            <ExpandLessIcon className="-mb-1.5" />
            <ExpandMoreIcon className="-mt-1.5" />
          </div>
        </button>
      </h2>
      <Menu
        id={MENU_ID}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={!!anchorEl}
        onClose={closeMenu}
        style={{ minWidth: anchorEl?.offsetWidth }}
        classes={MENU_CLASSES}
      >
        {(boards || []).map(({ boardId, boardTitle }) => (
          <MenuItem
            onClick={closeMenu}
            component={Link}
            to={generatePath(AuthRoutes.BOARD, { boardId })}
            key={boardId}
          >
            {boardTitle}
          </MenuItem>
        ))}
        {isOrgAdmin && (
          <MenuItem
            className="border-t border-solid border-grey-300 py-3 text-tertiary-main"
            onClick={() => {
              openDialog(Dialogs.CREATE_LIFECYCLE_BOARD, {
                onClose: closeDialog,
              });
              closeMenu();
            }}
            style={{ minWidth: anchorEl?.offsetWidth }}
          >
            {translate('BOARD_CREATE_NEW')}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}

export default LifecycleBoardSwitcher;
